/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeSeries } from './TimeSeries';
import {
    TimeSeriesFromJSON,
    TimeSeriesFromJSONTyped,
    TimeSeriesToJSON,
} from './TimeSeries';
import type { Point } from './Point';
import {
    PointFromJSON,
    PointFromJSONTyped,
    PointToJSON,
} from './Point';
import type { RangeDTO } from './RangeDTO';
import {
    RangeDTOFromJSON,
    RangeDTOFromJSONTyped,
    RangeDTOToJSON,
} from './RangeDTO';

/**
 * 
 * @export
 * @interface SingleTimeSeriesView
 */
export interface SingleTimeSeriesView {
    /**
     * 
     * @type {number}
     * @memberof SingleTimeSeriesView
     */
    baseline?: number;
    /**
     * Paths of run attributes referenced in the custom X formula without a default that the run doesn't have as a finite float or int value. The series has no values in that case.
     * @type {Array<string>}
     * @memberof SingleTimeSeriesView
     */
    missingRunAttributes?: Array<string>;
    /**
     * 
     * @type {TimeSeries}
     * @memberof SingleTimeSeriesView
     */
    timeSeries: TimeSeries;
    /**
     * 
     * @type {Array<Point>}
     * @memberof SingleTimeSeriesView
     */
    values: Array<Point>;
    /**
     * 
     * @type {RangeDTO}
     * @memberof SingleTimeSeriesView
     */
    xrange?: RangeDTO;
    /**
     * 
     * @type {RangeDTO}
     * @memberof SingleTimeSeriesView
     */
    yrange?: RangeDTO;
}

/**
 * Check if a given object implements the SingleTimeSeriesView interface.
 */
export function instanceOfSingleTimeSeriesView(value: object): value is SingleTimeSeriesView {
    if (!('timeSeries' in value) || value['timeSeries'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function SingleTimeSeriesViewFromJSON(json: any): SingleTimeSeriesView {
    return SingleTimeSeriesViewFromJSONTyped(json, false);
}

export function SingleTimeSeriesViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleTimeSeriesView {
    if (json == null) {
        return json;
    }
    return {
        
        'baseline': json['baseline'] == null ? undefined : json['baseline'],
        'missingRunAttributes': json['missingRunAttributes'] == null ? undefined : json['missingRunAttributes'],
        'timeSeries': TimeSeriesFromJSON(json['timeSeries']),
        'values': ((json['values'] as Array<any>).map(PointFromJSON)),
        'xrange': json['xrange'] == null ? undefined : RangeDTOFromJSON(json['xrange']),
        'yrange': json['yrange'] == null ? undefined : RangeDTOFromJSON(json['yrange']),
    };
}

export function SingleTimeSeriesViewToJSON(value?: SingleTimeSeriesView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'baseline': value['baseline'],
        'missingRunAttributes': value['missingRunAttributes'],
        'timeSeries': TimeSeriesToJSON(value['timeSeries']),
        'values': ((value['values'] as Array<any>).map(PointToJSON)),
        'xrange': RangeDTOToJSON(value['xrange']),
        'yrange': RangeDTOToJSON(value['yrange']),
    };
}

